"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactEbiSpecies = _interopRequireDefault(require("@ebi-gene-expression-group/react-ebi-species"));
var _renderContentListItems = _interopRequireDefault(require("./renderContentListItems"));
var _modelPropTypes = _interopRequireDefault(require("./modelPropTypes"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Card = function Card(_ref) {
  var iconType = _ref.iconType,
    iconSrc = _ref.iconSrc,
    description = _ref.description,
    content = _ref.content,
    speciesIconHeight = _ref.speciesIconHeight,
    imageIconHeight = _ref.imageIconHeight;
  var cardHero = iconType === "species" ? /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontSize: speciesIconHeight
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactEbiSpecies["default"], {
    species: iconSrc
  })) :
  /*#__PURE__*/
  // iconType === `image` ?  // Margin picked by trial and error to match EbiSpeciesIcon of size 8rem
  _react["default"].createElement("img", {
    src: iconSrc,
    style: {
      height: imageIconHeight,
      marginBottom: "2.35rem",
      marginTop: "2.50rem"
    }
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: 0,
      paddingBottom: "2rem",
      textAlign: "center"
    }
  }, description && description.url ? /*#__PURE__*/_react["default"].createElement("a", {
    style: {
      borderBottom: 0
    },
    href: description.url
  }, cardHero) : cardHero, description && /*#__PURE__*/_react["default"].createElement("h5", null, description.url ? /*#__PURE__*/_react["default"].createElement("a", {
    href: description.url
  }, description.text) : description.text), Array.isArray(content) && /*#__PURE__*/_react["default"].createElement("ul", {
    style: {
      listStyle: "none",
      marginLeft: 0
    }
  }, (0, _renderContentListItems["default"])(content)));
};
Card.propTypes = _objectSpread(_objectSpread({}, _modelPropTypes["default"]), {}, {
  speciesIconHeight: _propTypes["default"].string,
  imageIconHeight: _propTypes["default"].string
});
Card.defaultProps = {
  speciesIconHeight: "6rem",
  imageIconHeight: "3rem"
};
var _default = exports["default"] = Card;